import Button from "../button/button";
import "./hero.css";

import HeroImage from "../../assets/hero-2.gif";

export default function HeroBanner() {
  return (
    <div
      className="ae-hero-banner-container -fade-in"
      data-testid="hero-section"
    >
      <img className="ae-hero-banner-image" alt="" src={HeroImage} />
      <div className="ae-hero-cta-container">
        <div className="flip-container">
          <div className="flip-inner">
            <h1 className="ae-hero-cta-title flip-front">ActEd.</h1>
            <h2 className="ae-hero-cta-title flip-back">
              Active Educational Training.
            </h2>
          </div>
        </div>
        <p className="ae-hero-cta-text">
          Giving professionals the vehicle and tools to develop their confidence
          and professional skills in the workplace
        </p>
        <Button
          buttonText="Find out more"
          buttonLink="/training"
          theme="dark-theme"
        />
      </div>
    </div>
  );
}
